(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["pdp-steps"] && !Shopify.designMode) return;
  try {
    
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    var rows = Array.from(document.querySelectorAll('.pdp-steps__row'));
    if (!rows.length) return;

    function onScroll() {
      var mid = window.innerHeight * 0.55;
      rows.forEach(function (row) {
        var rect = row.getBoundingClientRect();
        var center = rect.top + rect.height / 2;
        row.classList.toggle('is-active', center < mid);
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  });
})();

  } catch(e) { console.error(e); }
})();
})();
